import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { IGSTOfferRawData, ISegmentOffer } from '../../utils/type';
import { ICustomResponse } from '../../../gstConfigs/utils/type';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestCreateOffer } = useService();

	const createOffer = (gstOffer: ISegmentOffer) => {
		setShowLoader(true);
		requestCreateOffer(app.appName, { ...gstOffer }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the GST Offer', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
		return {};
	};

	const handleFormSubmit = (submittedData: IGSTOfferRawData) => {
		createOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	const segmentList: { id: string; label: string[] } = history?.location?.state?.segmentList;
	return { data: getFormDefaults(segmentList), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
